// Patient overview section form field enum
export enum PatientOverviewFormField {
  // Demographics
  LEGAL_NAME = 'legalName',
  PREFERRED_NAME = 'preferredName',
  DATE_OF_BIRTH = 'dateOfBirth',
  ADDRESS = 'address',
  GENDER = 'gender',
  SEX = 'sex',
  MEDICAID_ID = 'medicaidId',

  // Care Team
  LEGAL_GUARDIAN_NAME = 'legalGuardianName',
  LEGAL_GUARDIAN_RELATION = 'legalGuardianRelation',
  CAREGIVERS = 'caregivers', // Form.List array field
  EMERGENCY_CONTACT_NAME = 'emergencyContactName',
  EMERGENCY_CONTACT_PHONE = 'emergencyContactPhone',
  EMERGENCY_CONTACT_ADDRESS = 'emergencyContactAddress',
  ALTERNATE_CAREGIVER_NAME = 'alternateCaregiverName',
  ALTERNATE_CAREGIVER_PHONE = 'alternateCaregiverPhone',
  ALTERNATE_CAREGIVER_ADDRESS = 'alternateCaregiverAddress'
}
